export enum FlowActionPanelAction {
  SELECT_ALL = 'selectAll',
  DESELECT_ALL = 'deselectAll',
  ZOOM_IN = 'zoomIn',
  ZOOM_OUT = 'zoomOut',
  UNDO = 'undo',
  REDO = 'redo',
  RESET_FLOW = 'resetFlow',
  FIT_TO_SCREEN = 'fitToScreen',
  ONE_TO_ONE = 'oneToOne',
  ADD_NODE = 'addNode',
  REMOVE_NODE = 'removeNode',
  EDIT_NODE = 'editNode',
  DRAG_START = 'dragStart',
  DRAG_END = 'dragEnd',
  TRANSFORM_CANVAS = 'transformCanvas',
  CHANGE_SELECTION = 'changeSelection',
  CREATE_NODE = 'createNode',
  MOVE_NODE = 'moveNodes',
  REMOVE_CONNECTION = 'removeConnection',
  CREATE_CONNECTION = 'createConnection',
  REASSIGN_CONNECTION = 'reassignConnection',
  NODE_CLICKED = 'nodeClicked',
  RESET_POSITIONS = 'resetPositions'
}
